const migrationStatus = {
  AWAITING_APPROVAL: 'AWAITING_APPROVAL',
  COMPLETED_WITH_ERRORS: 'COMPLETED_WITH_ERRORS',
  FAILED: 'FAILED',
  IS_LIVE_SCHEDULED_DELETION: 'IS_LIVE_SCHEDULED_DELETION',
  LIVE_PENDING_DELETION: 'LIVE_PENDING_DELETION',
  MIGRATED: 'MIGRATED',
  MIGRATING: 'MIGRATING',
  SCP_PUBLISHING_FAILED: 'SCP_PUBLISHING_FAILED',
  SCP_PUBLISHING_IN_PROGRESS: 'SCP_PUBLISHING_IN_PROGRESS'
};
export const isMigrationInProgressV2 = status => status === migrationStatus.MIGRATING;
export const isMigrationInProgress = isMigrationInProgressV2;
export const isMigrationAwaitingPublish = status => status === migrationStatus.AWAITING_APPROVAL || status === migrationStatus.COMPLETED_WITH_ERRORS;
export const isMigratedKBPublished = status => status === migrationStatus.IS_LIVE_SCHEDULED_DELETION || status === migrationStatus.LIVE_PENDING_DELETION || status === migrationStatus.MIGRATED;
export const isLegacyKBDeleted = status => status === migrationStatus.MIGRATED;
export const isMigrationFailed = status => status === migrationStatus.FAILED;